import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { InspectionTemplateModel } from 'shared/domain/template/inspectionTemplateModel';
import { readInspectionTemplateModels } from 'serviceWorker/services/inspectionTemplates/inspectionTemplateReads';
import * as inspectionTemplatesService from '../db/inspectionTemplates/inspectionTemplatesService';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { inspectionTemplateContract } from 'shared/domain/inspectionTemplate/inspectionTemplateContract';
import { makeErrorPublisher, makeEventPublisher, makeLoadedEventPublisher, readCollectionPayload } from 'serviceWorker/broadcasts/publishers';

export const broadcastAllInspectionTemplates = makeLoadedEventPublisher(
  inspectionTemplateContract,
  DomainMessagesTypes.allInspectionTemplates,
  () => readCollectionPayload(inspectionTemplatesService, readInspectionTemplateModels)
);

export const broadcastCreatedInspectionTemplate =
  makeEventPublisher(inspectionTemplateContract, DomainMessagesTypes.createdEntity);

export const broadcastUpdatedInspectionTemplate =
  makeEventPublisher(inspectionTemplateContract, DomainMessagesTypes.updatedEntity);

export const broadcastDeletedInspectionTemplate =
  makeEventPublisher(inspectionTemplateContract, DomainMessagesTypes.deletedEntity);

export const broadcastRestoredInspectionTemplate =
  makeEventPublisher(inspectionTemplateContract, DomainMessagesTypes.updatedEntity);

const broadcastInspectionTemplateError = makeErrorPublisher(inspectionTemplateContract);

/** A failed template or checklist item change, with its `uniqueId` and the server's `messageId`. */
export const broadcastInspectionTemplateUploadError = (error: unknown, uniqueId?: string): void => {
  broadcastInspectionTemplateError(DomainMessagesTypes.failUploadedEntity, error, {
    uniqueId,
    messageId: chooseErrorMessage(error) ?? undefined,
  });
};
